/**
 * The platform module (KPR-1667; docs/plans/ios-app.md, Decision 2;
 * docs/ARCHITECTURE.md § The platform module).
 *
 * ONE place answers every difference between a browser tab and the phone app:
 * where a copied link points, how a file is saved, printed or shared, how a
 * barcode is scanned, where a credential is kept. The rest of keepr imports
 * from here and never asks which one it is running in. Nothing outside
 * `src/platform` reads `window.location.origin` to build a link or imports
 * `@capacitor/*`: src/__tests__/platformSeam.test.js and an eslint rule hold
 * that line, and src/config/platformSeam.js lists the few same-origin checks
 * that are not links.
 *
 * Today there is one implementation, `web.js`. The app's (`capacitor.js`,
 * KPR-1671) is chosen here once it exists; its `siteOrigin()` answers
 * SITE_ORIGIN (config/publicSite.js), because a WebView's own origin is
 * `capacitor://localhost` and no one can open that link.
 */
import web from './web';

/** The interface: every implementation has every one of these. */
export const PLATFORM_MEMBERS = Object.freeze([
	'secureStore',
	'siteOrigin',
	'saveFile',
	'print',
	'share',
	'openExternal',
	'openAdmin',
	'scan',
	'pickFolder',
	'push',
	'network',
	'lifecycle',
	'store',
	'device',
]);

export { notAvailable } from './web';
export { anchorOf, withActiveAnchor } from './anchor';

const platform = web;

export const secureStore = platform.secureStore;
export const saveFile = (...args) => platform.saveFile(...args);
export const print = (...args) => platform.print(...args);
export const share = (...args) => platform.share(...args);
export const openExternal = (...args) => platform.openExternal(...args);
export const openAdmin = (...args) => platform.openAdmin(...args);
export const scan = platform.scan;
export const pickFolder = platform.pickFolder;
export const push = platform.push;
export const network = platform.network;
export const lifecycle = platform.lifecycle;
export const store = platform.store;
export const device = platform.device;

/** The origin of every link a person copies or shares ('' with no window, for a relative fallback). */
export function siteOrigin() {
	return platform.siteOrigin();
}

export default platform;
